// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file accounts/search_accounts_full.proto (package protos.accounts, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import { file_google_protobuf_wrappers } from "@bufbuild/protobuf/wkt";
import type { WorkLocation } from "../general/work_location_pb";
import { file_general_work_location } from "../general/work_location_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file accounts/search_accounts_full.proto.
 */
export const file_accounts_search_accounts_full: GenFile = /*@__PURE__*/
  fileDesc("CiNhY2NvdW50cy9zZWFyY2hfYWNjb3VudHNfZnVsbC5wcm90bxIPcHJvdG9zLmFjY291bnRzIvIDChlTZWFyY2hBY2NvdW50c0Z1bGxSZXF1ZXN0EkEKBnBhcmFtcxgBIAEoCzIxLnByb3Rvcy5hY2NvdW50cy5TZWFyY2hBY2NvdW50c0Z1bGxSZXF1ZXN0LlBhcmFtcxJFCghpbmNsdWRlcxgCIAEoCzIzLnByb3Rvcy5hY2NvdW50cy5TZWFyY2hBY2NvdW50c0Z1bGxSZXF1ZXN0LkluY2x1ZGVzEkkKCnBhZ2luYXRpb24YAyABKAsyNS5wcm90b3MuYWNjb3VudHMuU2VhcmNoQWNjb3VudHNGdWxsUmVxdWVzdC5QYWdpbmF0aW9uGoMBCgZQYXJhbXMSFAoMc2VhcmNoX3F1ZXJ5GAEgASgJEjAKDGV4Y2x1ZGVfc2VsZhgCIAEoCzIaLmdvb2dsZS5wcm90b2J1Zi5Cb29sVmFsdWUSMQoNaXNfY29ubmVjdGlvbhgDIAEoCzIaLmdvb2dsZS5wcm90b2J1Zi5Cb29sVmFsdWUaRQoISW5jbHVkZXMSDAoEbmFtZRgBIAEoCBIPCgdwZnBfdXJsGAIgASgIEhoKEm1haW5fd29ya19sb2NhdGlvbhgDIAEoCBozCgpQYWdpbmF0aW9uEhIKCnBhZ2VfdG9rZW4YASABKAkSEQoJcGFnZV9zaXplGAIgASgFIqQDChpTZWFyY2hBY2NvdW50c0Z1bGxSZXNwb25zZRJCCgZyZXN1bHQYASABKAsyMi5wcm90b3MuYWNjb3VudHMuU2VhcmNoQWNjb3VudHNGdWxsUmVzcG9uc2UuUmVzdWx0EkoKCnBhZ2luYXRpb24YAiABKAsyNi5wcm90b3MuYWNjb3VudHMuU2VhcmNoQWNjb3VudHNGdWxsUmVzcG9uc2UuUGFnaW5hdGlvbhrOAQoGUmVzdWx0EkwKCGFjY291bnRzGAEgAygLMjoucHJvdG9zLmFjY291bnRzLlNlYXJjaEFjY291bnRzRnVsbFJlc3BvbnNlLlJlc3VsdC5BY2NvdW50GnYKB0FjY291bnQSEgoKYWNjb3VudF9pZBgBIAEoCRIMCgRuYW1lGAIgASgJEg8KB3BmcF91cmwYAyABKAkSOAoSbWFpbl93b3JrX2xvY2F0aW9uGAQgASgOMhwucHJvdG9zLmdlbmVyYWwuV29ya0xvY2F0aW9uGiUKClBhZ2luYXRpb24SFwoPbmV4dF9wYWdlX3Rva2VuGAEgASgJYgZwcm90bzM", [file_google_protobuf_wrappers, file_general_work_location]);

/**
 * @generated from message protos.accounts.SearchAccountsFullRequest
 */
export type SearchAccountsFullRequest = Message<"protos.accounts.SearchAccountsFullRequest"> & {
  /**
   * @generated from field: protos.accounts.SearchAccountsFullRequest.Params params = 1;
   */
  params?: SearchAccountsFullRequest_Params | undefined;

  /**
   * @generated from field: protos.accounts.SearchAccountsFullRequest.Includes includes = 2;
   */
  includes?: SearchAccountsFullRequest_Includes | undefined;

  /**
   * @generated from field: protos.accounts.SearchAccountsFullRequest.Pagination pagination = 3;
   */
  pagination?: SearchAccountsFullRequest_Pagination | undefined;
};

/**
 * Describes the message protos.accounts.SearchAccountsFullRequest.
 * Use `create(SearchAccountsFullRequestSchema)` to create a new message.
 */
export const SearchAccountsFullRequestSchema: GenMessage<SearchAccountsFullRequest> = /*@__PURE__*/
  messageDesc(file_accounts_search_accounts_full, 0);

/**
 * @generated from message protos.accounts.SearchAccountsFullRequest.Params
 */
export type SearchAccountsFullRequest_Params = Message<"protos.accounts.SearchAccountsFullRequest.Params"> & {
  /**
   * @generated from field: string search_query = 1;
   */
  searchQuery: string;

  /**
   * @generated from field: google.protobuf.BoolValue exclude_self = 2;
   */
  excludeSelf?: boolean | undefined;

  /**
   * @generated from field: google.protobuf.BoolValue is_connection = 3;
   */
  isConnection?: boolean | undefined;
};

/**
 * Describes the message protos.accounts.SearchAccountsFullRequest.Params.
 * Use `create(SearchAccountsFullRequest_ParamsSchema)` to create a new message.
 */
export const SearchAccountsFullRequest_ParamsSchema: GenMessage<SearchAccountsFullRequest_Params> = /*@__PURE__*/
  messageDesc(file_accounts_search_accounts_full, 0, 0);

/**
 * @generated from message protos.accounts.SearchAccountsFullRequest.Includes
 */
export type SearchAccountsFullRequest_Includes = Message<"protos.accounts.SearchAccountsFullRequest.Includes"> & {
  /**
   * @generated from field: bool name = 1;
   */
  name: boolean;

  /**
   * @generated from field: bool pfp_url = 2;
   */
  pfpUrl: boolean;

  /**
   * @generated from field: bool main_work_location = 3;
   */
  mainWorkLocation: boolean;
};

/**
 * Describes the message protos.accounts.SearchAccountsFullRequest.Includes.
 * Use `create(SearchAccountsFullRequest_IncludesSchema)` to create a new message.
 */
export const SearchAccountsFullRequest_IncludesSchema: GenMessage<SearchAccountsFullRequest_Includes> = /*@__PURE__*/
  messageDesc(file_accounts_search_accounts_full, 0, 1);

/**
 * @generated from message protos.accounts.SearchAccountsFullRequest.Pagination
 */
export type SearchAccountsFullRequest_Pagination = Message<"protos.accounts.SearchAccountsFullRequest.Pagination"> & {
  /**
   * @generated from field: string page_token = 1;
   */
  pageToken: string;

  /**
   * @generated from field: int32 page_size = 2;
   */
  pageSize: number;
};

/**
 * Describes the message protos.accounts.SearchAccountsFullRequest.Pagination.
 * Use `create(SearchAccountsFullRequest_PaginationSchema)` to create a new message.
 */
export const SearchAccountsFullRequest_PaginationSchema: GenMessage<SearchAccountsFullRequest_Pagination> = /*@__PURE__*/
  messageDesc(file_accounts_search_accounts_full, 0, 2);

/**
 * @generated from message protos.accounts.SearchAccountsFullResponse
 */
export type SearchAccountsFullResponse = Message<"protos.accounts.SearchAccountsFullResponse"> & {
  /**
   * @generated from field: protos.accounts.SearchAccountsFullResponse.Result result = 1;
   */
  result?: SearchAccountsFullResponse_Result | undefined;

  /**
   * @generated from field: protos.accounts.SearchAccountsFullResponse.Pagination pagination = 2;
   */
  pagination?: SearchAccountsFullResponse_Pagination | undefined;
};

/**
 * Describes the message protos.accounts.SearchAccountsFullResponse.
 * Use `create(SearchAccountsFullResponseSchema)` to create a new message.
 */
export const SearchAccountsFullResponseSchema: GenMessage<SearchAccountsFullResponse> = /*@__PURE__*/
  messageDesc(file_accounts_search_accounts_full, 1);

/**
 * @generated from message protos.accounts.SearchAccountsFullResponse.Result
 */
export type SearchAccountsFullResponse_Result = Message<"protos.accounts.SearchAccountsFullResponse.Result"> & {
  /**
   * @generated from field: repeated protos.accounts.SearchAccountsFullResponse.Result.Account accounts = 1;
   */
  accounts: SearchAccountsFullResponse_Result_Account[];
};

/**
 * Describes the message protos.accounts.SearchAccountsFullResponse.Result.
 * Use `create(SearchAccountsFullResponse_ResultSchema)` to create a new message.
 */
export const SearchAccountsFullResponse_ResultSchema: GenMessage<SearchAccountsFullResponse_Result> = /*@__PURE__*/
  messageDesc(file_accounts_search_accounts_full, 1, 0);

/**
 * @generated from message protos.accounts.SearchAccountsFullResponse.Result.Account
 */
export type SearchAccountsFullResponse_Result_Account = Message<"protos.accounts.SearchAccountsFullResponse.Result.Account"> & {
  /**
   * @generated from field: string account_id = 1;
   */
  accountId: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: string pfp_url = 3;
   */
  pfpUrl: string;

  /**
   * @generated from field: protos.general.WorkLocation main_work_location = 4;
   */
  mainWorkLocation: WorkLocation;
};

/**
 * Describes the message protos.accounts.SearchAccountsFullResponse.Result.Account.
 * Use `create(SearchAccountsFullResponse_Result_AccountSchema)` to create a new message.
 */
export const SearchAccountsFullResponse_Result_AccountSchema: GenMessage<SearchAccountsFullResponse_Result_Account> = /*@__PURE__*/
  messageDesc(file_accounts_search_accounts_full, 1, 0, 0);

/**
 * @generated from message protos.accounts.SearchAccountsFullResponse.Pagination
 */
export type SearchAccountsFullResponse_Pagination = Message<"protos.accounts.SearchAccountsFullResponse.Pagination"> & {
  /**
   * @generated from field: string next_page_token = 1;
   */
  nextPageToken: string;
};

/**
 * Describes the message protos.accounts.SearchAccountsFullResponse.Pagination.
 * Use `create(SearchAccountsFullResponse_PaginationSchema)` to create a new message.
 */
export const SearchAccountsFullResponse_PaginationSchema: GenMessage<SearchAccountsFullResponse_Pagination> = /*@__PURE__*/
  messageDesc(file_accounts_search_accounts_full, 1, 1);

